module.exports = __webpack_public_path__ + "static/media/seemypetcam-4.12a04aa8.png";